module.exports = __webpack_public_path__ + "img/terracenew_box28.541cea11.jpg";